import { render } from "./Affiliate.vue?vue&type=template&id=0c4c68d6&scoped=true"
import script from "./Affiliate.vue?vue&type=script&lang=js"
export * from "./Affiliate.vue?vue&type=script&lang=js"

import "./Affiliate.vue?vue&type=style&index=0&id=0c4c68d6&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3818363008/src/bitbucket.org/island-c/cayman-fe-operator/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c4c68d6"]])

export default __exports__